'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Frame = require('./Frame');

var _Frame2 = _interopRequireDefault(_Frame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Frame2.default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-frame-component/lib/index.js
// module id = 837
// module chunks = 0